import dayjs from '../../../../utils/dayjs';

export const generateDailyActivity = () => {
  const dailyActivity = [];
  const daysQuantity = 35;
  for (let i = 0; i < daysQuantity; i++) {
    const winRatio = Math.floor(Math.random() * 100);
    const matches = winRatio * Math.floor(Math.random() * 20);
    const kda = matches ? Number((Math.random() * 100).toFixed(2)) : 0;
    dailyActivity.push({
      date: dayjs().subtract(daysQuantity - i, 'days').unix(),
      matches,
      winRatio,
      avgPerformance: winRatio,
      kda,
    });
  }
  return dailyActivity;
};

export const lolStatsMock = {
  general: {
    playerName: 'LoLName',
    tier: 'PLATINUM',
    rank: 'IV',
    lp: 55,
    matches: 55,
    wins: 55,
    winRatio: 55,
    avgPerformance: 55,
    kda: 4.75,
    csd: 55,
    goldShare: 55,
    damageShare: 70,
    positions: {
      mid: {
        matches: 123,
        winRatio: 40,
        kda: 2.57,
        goldShare: 20,
        visionScore: 39,
        champions: [
          {
            matches: 1,
            winRatio: 0,
            kda: 2.57,
            goldShare: 20,
            visionScore: 39,
            championId: 11,
            mastery: 1,
          },
          {
            matches: 99,
            winRatio: 40,
            kda: 5.22,
            goldShare: 20,
            visionScore: 90,
            championId: 161,
            mastery: 2,
          },
        ],
      },
      top: {
        matches: 123,
        winRatio: 0,
        kda: 20,
        goldShare: 23,
        visionScore: 15,
        champions: [
          {
            matches: 1,
            winRatio: 0,
            kda: 20,
            goldShare: 23,
            visionScore: 15,
            championId: 85,
            mastery: 1,
          },
        ],
      },
      support: {
        matches: 123,
        winRatio: 0,
        kda: 20,
        goldShare: 23,
        visionScore: 15,
        champions: [
          {
            matches: 1,
            winRatio: 0,
            kda: 20,
            goldShare: 23,
            visionScore: 15,
            championId: 117,
            mastery: 1,
          },
        ],
      },
      adc: {
        matches: 123,
        winRatio: 0,
        kda: 20,
        goldShare: 23,
        visionScore: 15,
        champions: [
          {
            matches: 1,
            winRatio: 0,
            kda: 20,
            goldShare: 23,
            visionScore: 15,
            championId: 110,
            mastery: 1,
          },
        ],
      },
      jungle: {
        matches: 123,
        winRatio: 0,
        kda: 20,
        goldShare: 23,
        visionScore: 15,
        champions: [
          {
            matches: 1,
            winRatio: 0,
            kda: 20,
            goldShare: 23,
            visionScore: 15,
            championId: 107,
            mastery: 1,
          },
        ],
      },
    },
    others: {
      kda: 4.75,
      csd: 0,
      goldShare: 44,
      damageShare: 44,
    },
  },
  activity: {
    dailyActivity: generateDailyActivity(),
    weekActivity: {
      hoursPlayed: 40,
      change: 79.89,
    },
    monthActivity: {
      hoursPlayed: 142,
      change: 140,
    },
    rankProgression: [
      {
        date: '1599264000',
        score: 0,
        tier: 'UNRANKED',
        rank: 'UNRANKED',
      }, {
        date: '1599868800',
        score: 0,
        tier: 'UNRANKED',
        rank: 'UNRANKED',
      }, {
        date: '1600473600',
        score: 70,
        tier: 'PLATINUM',
        rank: 'II',
      }, {
        date: '1601078400',
        score: 10,
        tier: 'PLATINUM',
        rank: 'I',
      }, {
        date: '1601683200',
        score: 80,
        tier: 'PLATINUM',
        rank: 'I',
      }, {
        date: '1602288000',
        score: 10,
        tier: 'DIAMOND',
        rank: 'IV',
      }, {
        date: '1602892800',
        score: 40,
        tier: 'DIAMOND',
        rank: 'IV',
      },
    ],
  },
  rank: {
    overall: 200,
    hub: 17,
    // state: 33,
    country: 80,
  },
};
export const lolStatsMock2 = {
  general: {
    playerName: 'LoLName',
    tier: 'CHALLENGER',
    rank: 'I',
    lp: 55,
    matches: 312,
    wins: 23,
    winRatio: 76,
    avgPerformance: 76,
    kda: 2.40,
    csd: 66,
    goldShare: 66,
    damageShare: 66,
    positions: {
      mid: {
        matches: 55,
        winRatio: 55,
        kda: 2.57,
        goldShare: 55,
        visionScore: 55,
        champions: [
          {
            matches: 1,
            winRatio: 0,
            kda: 2.57,
            goldShare: 20,
            visionScore: 39,
            championId: 99,
            mastery: 1,
          },
          {
            matches: 99,
            winRatio: 40,
            kda: 5.22,
            goldShare: 20,
            visionScore: 90,
            championId: 90,
            mastery: 2,
          },
        ],
      },
      top: {
        matches: 55,
        winRatio: 55,
        kda: 55,
        goldShare: 23,
        visionScore: 55,
        champions: [
          {
            matches: 1,
            winRatio: 0,
            kda: 20,
            goldShare: 23,
            visionScore: 15,
            championId: 85,
            mastery: 1,
          },
        ],
      },
      support: {
        matches: 55,
        winRatio: 55,
        kda: 55,
        goldShare: 23,
        visionScore: 55,
        champions: [
          {
            matches: 1,
            winRatio: 0,
            kda: 20,
            goldShare: 23,
            visionScore: 15,
            championId: 117,
            mastery: 1,
          },
        ],
      },
      adc: {
        matches: 55,
        winRatio: 55,
        kda: 55,
        goldShare: 23,
        visionScore: 55,
        champions: [
          {
            matches: 1,
            winRatio: 0,
            kda: 20,
            goldShare: 23,
            visionScore: 15,
            championId: 110,
            mastery: 1,
          },
        ],
      },
      // jungle: {
      //   matches: 55,
      //   winRatio: 55,
      //   kda: 55,
      //   goldShare: 23,
      //   visionScore: 55,
      //   champions: [
      //     {
      //       matches: 1,
      //       winRatio: 0,
      //       kda: 20,
      //       goldShare: 23,
      //       visionScore: 15,
      //       championId: 107,
      //       mastery: 1,
      //     },
      //   ],
      // },
    },
    others: {
      kda: 4.75,
      csd: 0,
      goldShare: 44,
      damageShare: 44,
    },
  },
  activity: {
    // dailyActivity: [],
    dailyActivity: generateDailyActivity(),
    weekActivity: {
      hoursPlayed: 40,
      change: 79.89,
    },
    monthActivity: {
      hoursPlayed: 142,
      change: 140,
    },
    rankProgression: [
      {
        date: '1599264000',
        score: 0,
        tier: 'GOLD',
        rank: 'IV',
      }, {
        date: '1599868800',
        score: 50,
        tier: 'GOLD',
        rank: 'IV',
      }, {
        date: '1600473600',
        score: 100,
        tier: 'GOLD',
        rank: 'IV',
      }, {
        date: '1601078400',
        score: 70,
        tier: 'GOLD',
        rank: 'IV',
      }, {
        date: '1601683200',
        score: 90,
        tier: 'GOLD',
        rank: 'IV',
      }, {
        date: '1602288000',
        score: 90,
        tier: 'GOLD',
        rank: 'IV',
      }, {
        date: '1602892800',
        score: 90,
        tier: 'GOLD',
        rank: 'IV',
      },
    ],
  },
  rank: {
    overall: 200,
    hub: 17,
    // state: 33,
    country: 80,
  },
};

export class LolPlayerData {
  constructor(data = {}) {
    this.general = data.general || false;
    this.queues = data.queues || false;
    this.activity = data.activity || false;
    this.rank = data.rank || false;
    this.rankProgression = data.rankProgression || false;
  }
}
